import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatSelectChange, MatTable } from '@angular/material';
import { SavingParameters, Parameter, LoanParameters } from '@akiba/models_bimbo';
import { LogicService } from '../../../services/logic.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';

@Component({
  selector: 'app-retirement-savings-loan-parameters',
  templateUrl: './retirement-savings-loan-parameters.component.html',
  styleUrls: ['./retirement-savings-loan-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RetirementSavingsLoanParametersComponent implements OnInit, OnDestroy {
  @ViewChild('rangeTable', { static: false }) rangeTable: MatTable<LoanParameters>;
  seniorityRangeColumns: string[] = ['start', 'end', 'edit', 'delete'];
  modParameter: Parameter | null = null;
  newLoanParameter: LoanParameters;


  editIndex = -1;

  parameterSubscription: Subscription;
  savingParameters: Array<Parameter> = new Array<Parameter>();
  //////////////////////////////////
  //////////////////////////////////

  contentLocation: AppState = new AppState();
  selectedIndex = 0;

  tempPeriod: SavingParameters;
  isEdit = false;

  saving = false;
  uploadSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService) {

    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 3);
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 3);

    }

  }

  ngOnInit() {
    this.modParameter = new Parameter();
  }

  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.modParameter = null;
      this.isEdit = false;
      this.tempPeriod = null;
    } else {
      const temp = event.value as Parameter;

      if (temp.loansParameters && temp.loansParameters.length > 0) {
        temp.applicableLoanParameter = temp.loansParameters[0];
      } else {
        const lp = new LoanParameters();
        temp.loansParameters.push(lp);
        temp.applicableLoanParameter = temp.loansParameters[0];
      }

      this.modParameter = temp;
      this.isEdit = true;
      this.tempPeriod = event.value;
    }

  }

  /**
   * agregar nuevo parametro de antiguedad y mas 
   */
  addSeniorityRange() {
    this.cancelSubscriptions();
    this.newLoanParameter = new LoanParameters();

    //this.doSubscriptions();
  }

  deleteLoanParameter(index: number) {
    const temp = this.modParameter.loansParameters;
    temp.splice(index, 1);
    this.modParameter.loansParameters = temp;
    if (this.rangeTable) {
      this.rangeTable.renderRows();
    }
  }

  async deleteParamLoan(index: number) {

    const temp = this.modParameter.loansParameters;
    temp.splice(index, 1);
    this.modParameter.loansParameters = temp;
    const aPeriodObj = this.modParameter.toAny();

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: 'Esta seguro que desea eliminar estos parametros',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        if (this.rangeTable) {
          this.rangeTable.renderRows();
        }
        await this.dataService.saveParameter(aPeriodObj);
      }
    });

  }

  editLoanParameter(index: number) {

    this.editIndex = index;
    //  this.cancelSubscriptions(); 
    this.newLoanParameter = this.modParameter.loansParameters[index];
    //this.doSubscriptions();
  }

  saveEditedPeriod() {

    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    if (!this.newLoanParameter.loanDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que se añada al menos una fecha al periodo.',
          close: 'Aceptar'
        }
      });
      return;
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'parameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };

        if (this.editIndex !== -1) {
          this.deleteLoanParameter(this.editIndex);
        }

        if (this.newLoanParameter.fileUploaded.file) {

          this.uploadService.pushUpload(this.newLoanParameter.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(async downloadURL => {

            this.newLoanParameter.fileUploaded.file = null;
            this.newLoanParameter.fileUploaded.downloadURL = downloadURL;
            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }
            this.modParameter.loansParameters.push(this.newLoanParameter);
            const aPeriodObj = this.modParameter.toAny();

            paramLogs.changeID = aPeriodObj.parametersID;
            this.dataService.saveLogAdministratorActions(paramLogs ,'retirementSavingsLoanParametersFileUploaded');
            await this.dataService.saveParameter(aPeriodObj);
            this.saving = false;

            this.reset();

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

            this.contentLocation.savingParametersIndex = 0;

          });

        } else {
          this.modParameter.loansParameters.push(this.newLoanParameter);
          const aPeriodObj = this.modParameter.toAny();
          paramLogs.changeID = aPeriodObj.parametersID;
          this.dataService.saveLogAdministratorActions(paramLogs ,'retirementSavingsLoanParameters');
          await this.dataService.saveParameter(aPeriodObj);
          this.saving = false;
          this.reset();

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'La información ha sido actualizada',
              close: 'Aceptar'
            }
          });

          this.contentLocation.savingParametersIndex = 0;


        }

      }
    });

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });

  }

  reset() {

    const lp = new LoanParameters();
    lp.maxEmployeeWageLoan = 1;
    const t = new Parameter();
    t.applicableLoanParameter = lp;
    this.modParameter = t;
    this.contentLocation.savingParametersIndex = 0;
    this.isEdit = false;
    this.tempPeriod = null;
    this.editIndex = -1;
    this.newLoanParameter = null;

  }

  cancelSubscriptions() {
    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.cancelSubscriptions();
  }

}
